module.exports = __webpack_public_path__ + "img/skridsko_skylt.a644239a.jpg";